import { useEffect, useState } from 'react';
import { useAuth, useFeatureEntitlements } from '@frontegg/react';
import { useSelector, useDispatch } from 'react-redux';
import { updateCurrentPractitionerSettings } from '../../../../store/actions/practitioner.action';
import { showToastSuccess } from 'src/utilities/toast';
import { analytics } from 'src/services';
import { Badge, Tooltip, Switch } from 'antd';
import { InfoCircleOutlined } from '@ant-design/icons';
import { UpgradeTooltip } from '../Payments/UpgradeTooltip';

export const MemoryFeatureFlag = () => {
  const { isEntitled: isMemoryEntitled } = useFeatureEntitlements('memory');
  const { currentPractitionerSettings } = useSelector((state) => ({
    ...state?.practitionerState,
  }));

  const dispatch = useDispatch();
  const [isMemoryEnabled, setIsMemoryEnabled] = useState(false);

  useEffect(() => {
    setIsMemoryEnabled(currentPractitionerSettings?.note_preferences?.memory);
  }, [currentPractitionerSettings]);

  const toggleMemoryEnabled = () => {
    let localPractitionerSettings = {
      note_preferences: {
        ...currentPractitionerSettings?.note_preferences,
        memory: !isMemoryEnabled,
      },
    };
    dispatch(updateCurrentPractitionerSettings(localPractitionerSettings));
    if (!isMemoryEnabled) {
      showToastSuccess(
        'Successfully enabled memory. Aura will now learn your writing style from future encounters'
      );
      analytics.track('Enabled Memory Setting in Memory', {
        email: user?.email,
      });
    } else {
      showToastSuccess('Successfully disabled memory');
      analytics.track('Disabled Memory Setting in Memory', {
        email: user?.email,
      });
    }
  };

  return (
    <div className="flex justify-start gap-2 mb-4">
      <div className="flex items-center gap-2">
        <span className="text-gray-600">Enable memory</span>
        <Badge count="beta" color="lightred" />
        <Tooltip
          title={
            <span>
              When enabled, we learn your writing style
              <br />
              by analyzing how you edit
              <br />
              generated summaries.
            </span>
          }
          placement="right"
        >
          <InfoCircleOutlined
            style={{ fontSize: '16px' }}
            className="text-gray-400 cursor-help"
          />
        </Tooltip>
      </div>
      <div className="flex items-center gap-2">
        {isMemoryEntitled ? (
          <Switch
            checked={isMemoryEnabled}
            onChange={toggleMemoryEnabled}
            className={`${isMemoryEnabled ? 'bg-[#00D090]' : 'bg-gray-200'}`}
          />
        ) : (
          <UpgradeTooltip>
            <Switch disabled defaultChecked={false} className="bg-gray-200" />
          </UpgradeTooltip>
        )}
      </div>
    </div>
  );
};
